module.exports = __webpack_public_path__ + "static/media/amazon.ccaf8705.PNG";